/** Motion — docs/sprocket-design-language.md §7. `prefers-reduced-motion` is honoured globally by the theme. */
export const MOTION = {
    duration: {
        /** Nav hover, row hover. */
        fast: 120,
        /** Buttons, inputs, chips. */
        base: 140,
        /** Drag lift. */
        slow: 160,
        /** Page content fading in after a skeleton. */
        fade: 150,
    },
    easing: 'ease',
};
//# sourceMappingURL=motion.js.map